function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "mobile-hi-dark_svg__st0",
  d: "M64 16h64c4.4 0 8 3.6 8 8v144c0 4.4-3.6 8-8 8H64c-4.4 0-8-3.6-8-8V24c0-4.4 3.6-8 8-8z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "mobile-hi-dark_svg__st1",
  d: "M128 174H64c-4.4 0-8-3.6-8-8v2c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-2c0 4.4-3.6 8-8 8z",
  fill: "#f0f0f0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "mobile-hi-dark_svg__st2",
  d: "M62 32h68c1.1 0 2 .9 2 2v118c0 1.1-.9 2-2 2H62c-1.1 0-2-.9-2-2V34c0-1.1.9-2 2-2z",
  fill: "#333"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "mobile-hi-dark_svg__st3",
  opacity: 0.24
}, /*#__PURE__*/React.createElement("path", {
  className: "mobile-hi-dark_svg__st2",
  d: "M130 33c.6 0 1 .4 1 1v118c0 .6-.4 1-1 1H62c-.6 0-1-.4-1-1V34c0-.6.4-1 1-1h68m0-1H62c-1.1 0-2 .9-2 2v118c0 1.1.9 2 2 2h68c1.1 0 2-.9 2-2V34c0-1.1-.9-2-2-2z",
  fill: "#333"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "mobile-hi-dark_svg__st4",
  d: "M88.7 24h14.6c.4 0 .7.3.7.7v.6c0 .4-.3.7-.7.7H88.7c-.4 0-.7-.3-.7-.7v-.6c0-.4.3-.7.7-.7z",
  fill: "#4a4d4e"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "mobile-hi-dark_svg__st5",
  d: "M82.7 24h.6c.4 0 .7.3.7.7v.6c0 .4-.3.7-.7.7h-.6c-.4 0-.7-.3-.7-.7v-.6c0-.4.3-.7.7-.7z",
  fill: "#e60000"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "mobile-hi-dark_svg__st5",
  cx: 96,
  cy: 164,
  r: 6,
  fill: "#e60000"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "mobile-hi-dark_svg__b1e8d3b6-820b-45a5-9d71-f0dfafcb9947",
  className: "mobile-hi-dark_svg__st6",
  fill: "none",
  d: "M0 0h192v192H0z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "mobile-hi-dark_svg__st7",
  d: "M131 55.7V35c0-1.1-.9-2-2-2H63c-1.1 0-2 .9-2 2v92.7l70-72z",
  fill: "#3f3f3f"
});

var SvgMobileHiDark = function SvgMobileHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile-hi-dark_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 192 192",
    xmlSpace: "preserve",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default SvgMobileHiDark;